import { Box, Stack } from "@mui/system";
import { spacing } from "../../../../../../../../../assets/styles/tokens";
import MissingDataCardItemView from "./MissingDataCardItemView";


// ─── Mock helper functions (replace with your actual imports) ─────────────────
const formatCurrency = (value: number): string => {
  if (value == null || isNaN(value)) return "$0";
  return "$" + Math.round(value).toLocaleString("en-US");
};

const formatPercent = (value: number): string => {
  if (value == null || isNaN(value)) return "0%";
  return Math.round(value * 100) + "%";
};
// ─────────────────────────────────────────────────────────────────────────────

// ─── Static demo data (replaces sortedData from API) ─────────────────────────
const staticData = [
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    qftd: 289,
    qftds: 300,
    qftd_status: "success",
    qftd_percentage: 0.96,
    budget_dollar: 60509,
    budgets_dollar: 57999,
    budget_status: "error",
    budget_percentage: 1.21,
    rr_budget_status: "error",
    rr_budget_percentage: 1.14,
    remaining_qftd: 52,
    cpa_income_dollar: 76711,
    total_income_dollar: 103220,
    cpa_budget_dollar: 103220,
    ftd: 423,
    runDate: "01/01/2026",
    runRange: "24/12/2025 - 01/01/2026",
    runBy: "System",
    status: "Success",
  },
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    qftd: 289,
    qftds: 300,
    qftd_status: "success",
    qftd_percentage: 0.96,
    budget_dollar: 60509,
    budgets_dollar: 57999,
    budget_status: "error",
    budget_percentage: 1.21,
    rr_budget_status: "error",
    rr_budget_percentage: 1.14,
    remaining_qftd: 52,
    cpa_income_dollar: 76711,
    total_income_dollar: 103220,
    cpa_budget_dollar: 103220,
    ftd: 423,
    runDate: "01/01/2026",
    runRange: "24/12/2025 - 01/01/2026",
    runBy: "System",
    status: "Success",
  },
];
// ─────────────────────────────────────────────────────────────────────────────

const MissingDataCardItem = ({
  sortedData = staticData,
}: {
  sortedData?: any[];
}) => {
  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <MissingDataCardItemView
              key={index}
              website_name={item.website_name}
              website_id={item.website_id}
              qftd={item.qftd}
              qftds={formatCurrency(item.qftds)}
              qftd_status={item.qftd_status}
              qftd_percentage={formatPercent(item.qftd_percentage)}
              budget_dollar={formatCurrency(item.budget_dollar)}
              budgets_dollar={formatCurrency(item.budgets_dollar)}
              budget_status={item.budget_status}
              budget_percentage={formatPercent(item.budget_percentage)}
              remaining_qftd={item.remaining_qftd}
              cpa_income_dollar={formatCurrency(item.cpa_income_dollar)}
              total_income_dollar={formatCurrency(item.total_income_dollar)}
              cpa_budget_dollar={formatCurrency(item.cpa_budget_dollar)}
              ftd={item.ftd}
              runDate={item.runDate}
              runRange={item.runRange}
              runBy={item.runBy}
              status={item.status}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default MissingDataCardItem;
